 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		84: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","4":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"container","11":"fc_executive_board","12":"fc_link-fc_link","13":"post-content-body","14":"aboutUsWpPage","15":"author","16":"category_page","17":"customCollectionPage","18":"fc-components-main-components","19":"feed","20":"loginPage","21":"logoutPage","22":"magazineTagPage","23":"magazine_page","24":"myAccountPage","25":"newsletters_page_marketo","26":"notFoundPage","27":"offerPage","28":"playlistIndexPage","29":"playlistPage","30":"podcastPage","31":"post_page","32":"registerPage","33":"resetPasswordPage","34":"sitemapIndex","35":"sitemapPost","36":"stories","37":"subscribePage","38":"tagPage","39":"videoIndex","40":"videoPage","41":"views-containers-layouts-blank_layout-blank_layout","42":"views-containers-layouts-web_layout-web_layout","79":"MarketoNewsletterForm","80":"MicCarousel","81":"MicIcon","82":"MicMobileIconCarousel","83":"Success-SubmissionSuccess","85":"applications-most-innovative-companies","86":"brands_that_matter_2021","87":"brands_that_matter_page","88":"categoryLink","89":"components-BackgroundHighlight-BackgroundHighlight","90":"components-MultiTabList-MultiTabList","91":"components-QuickCarousel-QuickCarousel","92":"components-StickyBar-StickyBar","93":"components-all_feed-all_feed","94":"components-categories","95":"components-config-config","96":"components-editor_highlights-editor_highlights","97":"components-finite_scroll","98":"components-footer-footer","99":"components-franchise_intro-franchise_intro","100":"components-ibd_category-ibd_category","101":"components-image-image","102":"components-magazine_archive-magazine_archive","103":"components-masthead-masthead","104":"components-mcp_section-mcp_section","105":"components-mic_mobile_menu-mic_mobile_menu","106":"components-more-stories-component-more-stories-component","107":"components-newsletters-recaptcha","108":"components-notice","109":"components-piano-pianoBottomBanner","110":"components-podcast_tile-podcast_tile","111":"components-podcast_tile-podcast_tile_featured","112":"components-post-content-insert","113":"components-ranked","114":"components-recirc-recirc","115":"components-related_posts-related_posts","116":"components-related_slider-related_slider","117":"components-sectors_list-sectors_list","118":"components-social-social","119":"components-top_50-top_50","120":"components-top_50_shuffle-top_50_shuffle","121":"components-video_megatron-video_megatron","122":"components-video_module-utils-video_module_ads","123":"components-video_module-video_module","124":"containers-pages-list_landers-bwi-2020","125":"containers-pages-list_landers-ibd-2020","126":"containers-pages-list_landers-mic-2021","127":"content-innovation_festival_banner","128":"content-sponsor_bar","129":"fc-components-main-components-StickyBar-StickyBar","130":"fc-components-main-containers","131":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","132":"fc-components-main-containers-IbdLayout-IbdLayout","133":"fc-components-main-containers-MicLayout-MicLayout","134":"fc-components-main-containers-WciLayout-WciLayout","135":"fc-components-main-utils-ConditionalWrapper","136":"franchises-BtmApplyPage","137":"franchises-BwiApplyPage","138":"franchises-IbdApplyPage","139":"franchises-MicApplyPage","140":"franchises-NbttApplyPage","141":"franchises-WciApplyPage","142":"innovation_by_design_future_page","143":"innovation_by_design_page_franchise","144":"innovation_by_design_page_franchise_2023","145":"layouts","146":"layouts-mcp","147":"nav_main_menu-nav_main_menu","148":"package_article_list_entry","149":"packages-nav-package_sticky_nav","150":"post-content-sidebar","151":"topics"}[chunkId]||chunkId) + "." + {"1":"3bf1ff4651a314f8c774","2":"5c8113eed72db91695be","3":"49ec8f73464e99889f0b","4":"e1f2195124e8f77495df","5":"491ea0c379bc8a6f9d02","6":"165266ef1a3f0ced42a9","7":"fbe954b33dcf17eb88a8","8":"1446abba34b2af1c6730","9":"a1f23be05899e16e933f","10":"3a0cbd24463fe8a049a8","11":"2b042e6184cb1161e92a","12":"0af0ad1545f96c159427","13":"b9f916642ae45cf352a1","14":"5194488cfdc10f2776ca","15":"704b2b519c3a107ad958","16":"27f1e80d4b66eac56c33","17":"ccfe5b02d1bd88183fae","18":"37085a2330e9532841d2","19":"af00650a299a6c7e4196","20":"9f345f034562c9736e02","21":"1e1b5c17d035bdff04da","22":"bd91874d34d9f845be31","23":"2970173a8f5b81ab80f1","24":"9e9768eb5c7a1074fe15","25":"a58e8bb04bfea5573380","26":"04d5eb346ab9a19e8d12","27":"b6ad9846c481cd6c6f14","28":"d84bcf784a8b03e1c199","29":"34bdc95384aa34ea9101","30":"47bd88b6066403816253","31":"82a7834040c4db0ffa8e","32":"306ad411f7a1965493bc","33":"533d1547ab0eee0ef4e9","34":"04cb2552c631bfa12e19","35":"03116c98d5885cb18624","36":"949852f44e7b19c427ea","37":"c0b3061eb61b08fe4bb5","38":"2ea2f5e43b12e3b6477c","39":"a24f743f40f959d1398f","40":"9885dfd50aab761f2ca0","41":"95ecd4051bc40d5b7268","42":"59fcbb6bf16c7883704f","43":"fa4130135023b0acc998","44":"1ee19664b3b6a34a9fb6","45":"272c53aebcfa33321a8b","46":"ec129871d55547e221f0","47":"7947e2cad7a1adb52ff5","48":"1c72183061023fae66a4","49":"ae8607d530565676406f","50":"b4bb22605e1b21bad99f","51":"f3feca123ffa0bfcc008","52":"0c735faa599db351a092","53":"62bed6851613bdd1c355","54":"70c5ddfa35a8bb7e422d","55":"451511b804964be7e4a2","56":"ccad9b7b812f78c3b9fd","57":"1ae4e26b42f3c45b3dd0","58":"edf706321c82ead9aa80","59":"1659d00ef00bde798569","60":"89499a10800ae97995ac","61":"6ec923a1125ac9cbee4e","62":"6a62b7729abe11fc0627","63":"d2a260eaa1854f4a9be6","64":"7e6c537770743e7341c1","65":"bda2717e5a5a3c25d093","66":"ec3cd34dd8e2c2db412d","67":"344eaa90b67e7552d99d","68":"6ee0fdb72c7c959750ad","69":"79204f0d2a42f7f1ede1","70":"e90f2bc627ceff147e59","71":"4fdc17004ab5e4ef9ff2","72":"512512d3a269740136f3","73":"0f750f38bda6fce8852f","74":"93637112656409f05940","75":"d5c70589697cfaaef9ee","76":"b1fce2d00349ce67c73e","77":"05569a097db52cb68d88","78":"e39a95d2893b898432ec","79":"423c4adc3e665618bc7c","80":"0ac8b7def8558ecdc26c","81":"b8b92ae5ff7e4eeee48a","82":"9074d66d9c548d8d752e","83":"14e5d6b2814494450fdd","85":"c3019c24a2caa5792db9","86":"2b87f92f2c3e2aa1b445","87":"db5496d823c516833cef","88":"21d8f2964b3988845b2b","89":"44ca650f0cf2aa316d6e","90":"ac5204c73f447299113a","91":"5104b7e5b2794b97f454","92":"6ee96ff5fa8f533a0c3b","93":"285c6a3a63cb1527ab51","94":"e10bee201ea42fd66dec","95":"7db9595f2aa065ef10af","96":"aa681f8044f864b2f289","97":"a652935fa48b2dac782a","98":"0d870beb00f3f0bb7f91","99":"2f060b6a1c75e5b12829","100":"8cce21623625ce9610e3","101":"b59a5deea7bd56e35f31","102":"c1300ee6868311416447","103":"24e8646f5657e48c1700","104":"452e8ba4c40831e8c923","105":"571584b1892ece24edb4","106":"5634756422e5843f3082","107":"e6dece2c33b941f5b977","108":"3a0d37cc8205fa08dbe2","109":"1638158afa75234a05d7","110":"6c0d0b1c49eba3ea397a","111":"6073a180b9dc41c23af0","112":"ef0cdf817a5ef769b2b7","113":"29cfbf6b1e911ad2b038","114":"d1b57050665ca936640a","115":"bff482f8a9afcd38d17a","116":"89de234a03d445145c41","117":"c94742d37c1dceb6cdc6","118":"57c3a020da027fd69da9","119":"374e988a56d918297ee6","120":"5d4b4570d5f010f968e8","121":"c93584cc1de9668de7ac","122":"d338eb85830af6e49028","123":"3df7afe4cd0f80f10a8a","124":"45bf1fd83ba61687f8df","125":"a71ea6da2841b1d52632","126":"ca7ae7f8b1502c140dcf","127":"41963e1a7922eb7564da","128":"dca7f314e139fdeebfa6","129":"4008a8fe67a8447f33a6","130":"6915592b58011258043e","131":"8b57a505175789bdb8fb","132":"0a7f4ac0c6cd73e0c755","133":"75930e1c1c1b6dcc50df","134":"8880fa3a7d79cae70153","135":"d03375f330a2c80817b7","136":"572534f2828d3d226e33","137":"1df665839d2ae9cd7c46","138":"4adaef5cc1c41850d5e6","139":"88d78f7d9990fe733255","140":"a650a0dc73e5253a0042","141":"0025177e3b0c39614616","142":"636b9789561004366173","143":"92c89445ceb02fddb7dd","144":"67b2d1afe8e15d6ec7a7","145":"100681efd008867246ab","146":"20f1423eed93f0efd2a5","147":"110561ccb68373698890","148":"4f778a1ad08736e6afa7","149":"87b9c191375b4f91f4d4","150":"5a1ba0cfce1186c0e0cd","151":"d492052eb033be17f097"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([861,152,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
